export const DESTINATION_KEY = 'destination'
export const RESIDENCE_COUNTRY_KEY = 'residenceCountry'
export const DEPARTURE_DATE_KEY = 'departureDate'
export const RETURN_DATE_KEY = 'returnDate'
export const TRIP_TYPE_KEY = 'tripType'
export const PREV_TRIP_TYPE_KEY = 'prevTripType'
export const ADULTS_COUNT_KEY = 'adultsCount'
export const CHILDREN_COUNT_KEY = 'childrenCount'
export const EMAIL_KEY = 'email'
export const PHONE_KEY = 'phone'
export const MASKED_PHONE_KEY = 'maskedPhone'
export const PROMOCODE_KEY = 'promocode'

export const SELECTED_PLAN_KEY = 'selectedPlan'

export const FIRST_NAME_KEY = 'firstName'
export const FAMILY_NAME_KEY = 'familyName'
export const DATE_OF_BIRTH_KEY = 'dateOfBirth'
export const NATIONALITY_KEY = 'nationality'
export const EMIRATES_ID_KEY = 'emiratesId'
export const CIVIL_ID_EXPIRY_DATE_KEY = 'civilIdExpiryDate'
export const PASSPORT_NUMBER_KEY = 'passportNumber'
export const WITH_WINTER_SPORT_KEY = 'withWinterSport'
export const WITH_COVID_KEY = 'withCovidKey'
export const WITH_CYBER_KEY = 'withCyberKey'
export const COUNTRY_CODE_KEY = 'countryCode'
export const LAST_FLOW_DIRECTION_KEY = 'lastFlowDirection'
export const PAYMENT_METHOD = 'paymentMethod'
export const IS_AFFINITY = 'isAffinity'
export const REDIRECT_URL = 'redirectURL'
export const IS_HERO_SECTION = 'isHeroSection'
export const GENDER_KEY = 'gender'
export const PREFERRED_REWARD_KEY = 'preferredReward'

export const REQUIRED_FIELDS = [EMAIL_KEY, PHONE_KEY]
export const PERSONAL_FIELDS = [
  FIRST_NAME_KEY,
  FAMILY_NAME_KEY,
  NATIONALITY_KEY,
  PASSPORT_NUMBER_KEY,
  DATE_OF_BIRTH_KEY,
  GENDER_KEY,
]
export const OUTBOUND_PERSONAL_FIELDS = [EMIRATES_ID_KEY, CIVIL_ID_EXPIRY_DATE_KEY]
